import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { CompanyLogo } from "../../../Wrap/Models/Domains/Company/CompanyLogo";
import { FirmLogoDispatcher } from "./Variable";

export interface FirmLogoStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    logoUrl?: CompanyLogo;
}

export class FirmLogoStoreStatic extends BaseStore<FirmLogoStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(FirmLogoDispatcher, (actionData) => this.onFirmLogoStoreResponse(actionData));
    }

    public getLastResult(): FirmLogoStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): FirmLogoStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getFirmLogoInfo(): CompanyLogo {
        return this.getState().logoUrl;
    }

    private onFirmLogoStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    logoUrl: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
